import { Fragment } from 'react'
import { SPTopExtend } from 'components/top-sp/extend'
import { FV } from './fv'
import { SPHeader } from 'components/common/header/sp'
import { SPPointContact } from 'components/point-sp/contact'

export function TopViewSp() {
  return (
    <Fragment>
      <SPHeader />
      <SPPointContact />
      <FV />
      <SPTopExtend />
    </Fragment>
  )
}
